module.exports = __webpack_public_path__ + "static/media/sidebar-art-paylease.da0c7177.png";